import type { Ref } from 'react'

interface Props {
  onRefresh: () => void
  progressLabel?: string
  actionLabel?: string
  buttonRef?: Ref<HTMLButtonElement>
}

/** One refresh control and progress treatment for desktop and touch headers. */
export function StudioBrand({ onRefresh, progressLabel, actionLabel = 'Refresh notes', buttonRef }: Props) {
  return <div className="studio-brand-area">
    <button ref={buttonRef} className="studio-brand" type="button" onClick={onRefresh} aria-label={actionLabel}>
      <span className="studio-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M4 17V7.5h2.5v1.2C7.2 7.5 8.2 7 9.5 7c1.5 0 2.6.6 3.2 1.8C13.5 7.6 14.7 7 16.1 7 18.6 7 20 8.5 20 11.1V17h-2.7v-5.6c0-1.4-.6-2.1-1.7-2.1-1.3 0-2 .9-2 2.3V17h-2.7v-5.6c0-1.4-.6-2.1-1.7-2.1-1.3 0-2.5.9-2.5 2.3V17Z"/>
        </svg>
      </span><span>miniMany</span>
    </button>
    {progressLabel ? <span className="app-header__sync-progress studio-sync-progress" role="progressbar" aria-label={progressLabel}/> : null}
  </div>
}
